// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__e-kS+","list":"styles_list__kWNdx","btn":"styles_btn__ud+1S","active":"styles_active__u-SnE"};